import { apiRequest } from '../../api/client';

export async function getCustomPlanByToken(token) {
  return apiRequest(`/api/public/custom-plans/invites/${encodeURIComponent(token)}`);
}

export async function acceptCustomPlanInvite({
  token,
  idToken,
  firstName,
  lastName,
  companyName,
  subscription,
}) {
  return apiRequest(`/api/custom-plans/invites/${encodeURIComponent(token)}/accept`, {
    method: 'POST',
    token: idToken,
    body: {
      firstName,
      lastName,
      companyName,
      subscription,
    },
  });
}
